var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 16C33.3724 16 28 21.1806 28 27.5715C28 36.5716 35.8429 42.1554 38.8477 45.5736C39.4563 46.266 40.5449 46.266 41.1525 45.5736C44.1573 42.1554 52.0002 35.592 52.0002 27.5715C52.0002 21.1806 46.6278 16 40.0001 16ZM40.0001 31.4287C37.7906 31.4287 36.0001 29.7022 36.0001 27.5715C36.0001 25.4409 37.7906 23.7144 40.0001 23.7144C42.2097 23.7144 44.0002 25.4409 44.0002 27.5715C44.0002 29.7022 42.2097 31.4287 40.0001 31.4287Z",
    stroke: "#FF6633",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3689 36.5713H17.1631L6.69531 64.0001H73.3082L61.8889 36.5713H56.655",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 59.1051C16.1639 55.5133 21.7803 48.7214 31.1845 50.2887C42.9397 52.2479 52.7357 53.2275 57.6337 44.4111",
    stroke: "#FF6633",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeDasharray: "2.67 2.67"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOrange);
export default __webpack_public_path__ + "static/media/map-orange.0f782616e46a96408b05dcb61a385145.svg";
export { ForwardRef as ReactComponent };